// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2a-Nd","largestCol":"styles_largestCol__Q4Jhe","smallestCol":"styles_smallestCol__1LkBf"};